var q = /* @__PURE__ */ ((e) => (e.email = "email", e.profile = "profile", e.openid = "openid", e.offline_access = "offline", e))(q || {}), V = /* @__PURE__ */ ((e) => (e.none = "none", e.create = "create", e.login = "login", e))(V || {}), I = /* @__PURE__ */ ((e) => (e.logout = "logout", e.login = "login", e.register = "registration", e.token = "token", e.profile = "profile", e))(I || {}), w = /* @__PURE__ */ ((e) => (e[e.refreshToken = 0] = "refreshToken", e[e.cookie = 1] = "cookie", e))(w || {});
const L = (e) => {
  const t = (l) => btoa(l).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  if (e instanceof ArrayBuffer) {
    const l = new Uint8Array(e), c = String.fromCharCode(...l);
    return t(c);
  }
  const n = new TextEncoder().encode(e), s = String.fromCharCode(...n);
  return t(s);
}, C = (e = 28) => {
  if (crypto) {
    const t = new Uint8Array(e / 2);
    return crypto.getRandomValues(t), Array.from(t, H).join("");
  } else
    return B(e);
};
function H(e) {
  return e.toString(16).padStart(2, "0");
}
function B(e = 28) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let r = "";
  const n = t.length;
  for (let s = 0; s < e; s++)
    r += t.charAt(Math.floor(Math.random() * n));
  return r;
}
const K = (e) => {
  e = e.split("?")[1];
  const t = new URLSearchParams(e);
  return {
    accessToken: t.get("access_token"),
    idToken: t.get("id_token"),
    expiresIn: +(t.get("expires_in") || 0)
  };
}, D = (e) => e.replace(/\/$/, ""), J = (e, t = !1) => {
  const r = Array.isArray(e.audience) ? e.audience.join(" ") : e.audience || "", n = {
    login_hint: e.loginHint,
    is_create_org: e.isCreateOrg?.toString(),
    connection_id: e.connectionId,
    redirect_uri: e.redirectURL ? t ? e.redirectURL : D(e.redirectURL) : void 0,
    audience: r,
    scope: e.scope?.join(" ") || "email profile openid offline",
    prompt: e.prompt,
    lang: e.lang,
    org_code: e.orgCode,
    org_name: e.orgName,
    has_success_page: e.hasSuccessPage?.toString(),
    workflow_deployment_id: e.workflowDeploymentId,
    supports_reauth: e.supportsReauth?.toString(),
    plan_interest: e.planInterest
  };
  return Object.keys(n).forEach(
    (s) => n[s] === void 0 && delete n[s]
  ), n;
}, P = (e) => typeof e != "object" || e === null ? e : Array.isArray(e) ? e.map((t) => P(t)) : Object.fromEntries(
  Object.entries(e).map(([t, r]) => [
    t.replace(/_([a-z])/g, (n, s) => s.toUpperCase()),
    P(r)
  ])
), G = [
  // UTM tags
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  // Google Ads smart campaign tracking
  "gclid",
  "click_id",
  "hsa_acc",
  "hsa_cam",
  "hsa_grp",
  "hsa_ad",
  "hsa_src",
  "hsa_tgt",
  "hsa_kw",
  "hsa_mt",
  "hsa_net",
  "hsa_ver",
  // Marketing category
  "match_type",
  "keyword",
  "device",
  "ad_group_id",
  "campaign_id",
  "creative",
  "network",
  "ad_position",
  "fbclid",
  "li_fat_id",
  "msclkid",
  "twclid",
  "ttclid"
], ee = async (e, t = I.login, r, n) => {
  const s = `${e}/oauth2/auth`, l = p();
  if (r.reauthState)
    try {
      const i = P(
        JSON.parse(atob(r.reauthState))
      );
      r = {
        ...r,
        ...i
      }, delete r.reauthState;
    } catch (i) {
      const h = i instanceof Error ? i.message : "Unknown error";
      throw new Error(`Error handing reauth state: ${h}`);
    }
  if (!r.clientId)
    throw new Error("Error generating auth URL: Client ID missing");
  const c = {
    client_id: r.clientId,
    response_type: r.responseType || "code",
    ...J(r, n?.disableUrlSanitization)
  };
  r.state || (r.state = C(32)), l && l.setSessionItem(o.state, r.state), c.state = r.state, r.nonce || (r.nonce = C(16)), c.nonce = r.nonce, l && l.setSessionItem(o.nonce, r.nonce);
  let f = "";
  if (r.codeChallenge)
    c.code_challenge = r.codeChallenge;
  else {
    const { codeVerifier: i, codeChallenge: h } = await W();
    f = i, l && l.setSessionItem(o.codeVerifier, i), c.code_challenge = h;
  }
  c.code_challenge_method = "S256", r.codeChallengeMethod && (c.code_challenge_method = r.codeChallengeMethod), !r.prompt && t === I.register && (c.prompt = V.create), r.properties && Object.keys(r.properties).forEach((i) => {
    if (!G.includes(i)) {
      console.warn("Unsupported Property for url generation: ", i);
      return;
    }
    const h = r.properties?.[i];
    h !== void 0 && (c[i] = h);
  });
  const u = new URLSearchParams(c).toString();
  return {
    url: new URL(`${s}?${u}`),
    state: c.state,
    nonce: c.nonce,
    codeChallenge: c.code_challenge,
    codeVerifier: f
  };
};
async function W() {
  const e = C(52), t = new TextEncoder().encode(e);
  let r = "";
  if (!crypto)
    r = L(btoa(e));
  else {
    const n = await crypto.subtle.digest("SHA-256", t);
    r = L(n);
  }
  return { codeVerifier: e, codeChallenge: r };
}
let $;
function F(e, t) {
  if (U(), typeof window > "u")
    throw new Error("setRefreshTimer requires a browser environment");
  if (e <= 0)
    throw new Error("Timer duration must be positive");
  $ = window.setTimeout(
    t,
    Math.min(e * 1e3 - 1e4, 864e5)
  );
}
function U() {
  $ !== void 0 && (window.clearTimeout($), $ = void 0);
}
const _ = {
  framework: "",
  frameworkVersion: "",
  sdkVersion: ""
}, N = async () => {
  await p()?.removeItems(
    o.state,
    o.nonce,
    o.codeVerifier
  );
}, re = async ({
  urlParams: e,
  domain: t,
  clientId: r,
  redirectURL: n,
  autoRefresh: s = !1,
  onRefresh: l
}) => {
  const c = e.get("state"), f = e.get("code");
  if (!c || !f)
    return console.error("Invalid state or code"), {
      success: !1,
      error: "Invalid state or code"
    };
  const u = p();
  if (!u)
    return console.error("No active storage found"), {
      success: !1,
      error: "Authentication storage is not initialized"
    };
  (!_.framework || !_.frameworkVersion) && console.warn(
    "Framework and version not set. Please set the framework and version in the config object"
  );
  const i = await u.getSessionItem(o.state);
  if (c !== i)
    return console.error("Invalid state"), {
      success: !1,
      error: `Invalid state; supplied ${c}, expected ${i}`
    };
  const h = await u.getSessionItem(
    o.codeVerifier
  );
  if (h === null)
    return console.error("Code verifier not found"), {
      success: !1,
      error: "Code verifier not found"
    };
  const R = {
    "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
  };
  _.framework && (R["Kinde-SDK"] = `${_.framework}/${_.sdkVersion}/${_.frameworkVersion}/Javascript`);
  const z = {
    method: "POST",
    ...!a.useInsecureForRefreshToken && v(t) ? {
      credentials: "include"
    } : {},
    headers: new Headers(R),
    body: new URLSearchParams({
      client_id: r,
      code: f,
      code_verifier: h,
      grant_type: "authorization_code",
      redirect_uri: n
    })
  };
  let S;
  U();
  try {
    if (S = await fetch(`${t}/oauth2/token`, z), !S?.ok) {
      const k = await S.text();
      return console.error("Token exchange failed:", S.status, k), {
        success: !1,
        error: `Token exchange failed: ${S.status} - ${k}`
      };
    }
  } catch (k) {
    return N(), console.error("Token exchange failed:", k), {
      success: !1,
      error: `Token exchange failed: ${k}`
    };
  }
  const d = await S.json(), b = y();
  b && b.setItems({
    [o.accessToken]: d.access_token,
    [o.idToken]: d.id_token,
    [o.refreshToken]: d.refresh_token
  }), (a.useInsecureForRefreshToken || !v(t)) && u.setSessionItem(o.refreshToken, d.refresh_token), s && F(d.expires_in, async () => {
    x({ domain: t, clientId: r, onRefresh: l });
  }), N();
  const j = ((k) => (k.search = "", k))(new URL(window.location.toString()));
  return window.history.replaceState(window.history.state, "", j), !d.access_token || !d.id_token || !d.refresh_token ? {
    success: !1,
    error: "No access token received"
  } : {
    success: !0,
    [o.accessToken]: d.access_token,
    [o.idToken]: d.id_token,
    [o.refreshToken]: d.refresh_token
  };
};
function Z(e) {
  const r = document.cookie.split("; ").find((n) => n.startsWith(`${e}=`));
  if (!r) return null;
  try {
    const n = r.split("=")[1];
    return n ? decodeURIComponent(n) : null;
  } catch (n) {
    return console.error(`Error parsing cookie ${e}:`, n), null;
  }
}
const Q = "_kbrte", te = async ({
  domain: e,
  clientId: t
}) => {
  if (!e)
    return {
      success: !1,
      error: "Domain is required for authentication check"
    };
  if (!t)
    return {
      success: !1,
      error: "Client ID is required for authentication check"
    };
  const r = v(e), n = a.useInsecureForRefreshToken;
  let s = null;
  return r && !n && (s = Z(Q)), await x({
    domain: e,
    clientId: t,
    refreshType: s ? w.cookie : w.refreshToken
  });
}, v = (e) => !e.match(
  /^(?:https?:\/\/)?[a-zA-Z0-9][.-a-zA-Z0-9]*\.kinde\.com$/i
);
function A(e, t) {
  return t <= 0 ? [] : e.match(new RegExp(`.{1,${t}}`, "g")) || [];
}
function X(e, t) {
  if (!e)
    return null;
  const r = e.split(".");
  if (r.length !== 3)
    return null;
  const n = r[
    1
    /* body */
  ].replace(/-/g, "+").replace(/_/g, "/"), s = decodeURIComponent(
    atob(n).split("").map((l) => "%" + ("00" + l.charCodeAt(0).toString(16)).slice(-2)).join("")
  );
  return JSON.parse(s);
}
var o = /* @__PURE__ */ ((e) => (e.accessToken = "accessToken", e.idToken = "idToken", e.refreshToken = "refreshToken", e.state = "state", e.nonce = "nonce", e.codeVerifier = "codeVerifier", e))(o || {});
class E {
  async setItems(t) {
    await Promise.all(
      Object.entries(t).map(
        ([r, n]) => this.setSessionItem(r, n)
      )
    );
  }
  async removeItems(...t) {
    await Promise.all(
      t.map((r) => this.removeSessionItem(r))
    );
  }
}
class ne extends E {
  memCache = {};
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    this.memCache = {};
  }
  /**
   * Sets the provided key-value store to the memory cache.
   * @param {string} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(t, r) {
    if (await this.removeSessionItem(t), typeof r == "string") {
      A(r, a.maxLength).forEach(
        (n, s) => {
          this.memCache[`${a.keyPrefix}${t}${s}`] = n;
        }
      );
      return;
    }
    this.memCache[`${a.keyPrefix}${String(t)}0`] = r;
  }
  /**
   * Gets the item for the provided key from the memory cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(t) {
    if (this.memCache[`${a.keyPrefix}${String(t)}0`] === void 0)
      return null;
    let r = "", n = 0, s = `${a.keyPrefix}${String(t)}${n}`;
    for (; this.memCache[s] !== void 0; )
      r += this.memCache[s], n++, s = `${a.keyPrefix}${String(t)}${n}`;
    return r;
  }
  /**
   * Removes the item for the provided key from the memory cache.
   * @param {string} itemKey
   * @returns {void}
   */
  async removeSessionItem(t) {
    for (const r in this.memCache)
      r.startsWith(`${a.keyPrefix}${String(t)}`) && delete this.memCache[r];
  }
}
function T(e) {
  return new Promise((t, r) => {
    chrome.storage.local.get([e], function(n) {
      chrome.runtime.lastError ? r(void 0) : t(n[e]);
    });
  });
}
class se extends E {
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    await chrome.storage.local.clear();
  }
  /**
   * Sets the provided key-value store to the chrome.store.local.
   * @param {string} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(t, r) {
    if (await this.removeSessionItem(t), typeof r == "string") {
      A(r, a.maxLength).forEach(
        async (n, s) => {
          await chrome.storage.local.set({
            [`${a.keyPrefix}${t}${s}`]: n
          });
        }
      );
      return;
    }
    await chrome.storage.local.set({
      [`${a.keyPrefix}${t}0`]: r
    });
  }
  /**
   * Gets the item for the provided key from the chrome.store.local cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(t) {
    let r = "", n = 0, s = `${a.keyPrefix}${String(t)}${n}`;
    for (; await T(
      `${a.keyPrefix}${String(t)}${n}`
    ) !== void 0; )
      r += await T(s), n++, s = `${a.keyPrefix}${String(t)}${n}`;
    return r;
  }
  /**
   * Removes the item for the provided key from the chrome.store.local cache.
   * @param {string} itemKey
   * @returns {void}
   */
  async removeSessionItem(t) {
    let r = 0;
    for (; await T(
      `${a.keyPrefix}${String(t)}${r}`
    ) !== void 0; )
      await chrome.storage.local.remove(
        `${a.keyPrefix}${String(t)}${r}`
      ), r++;
  }
}
class oe extends E {
  constructor() {
    super(), a.useInsecureForRefreshToken && console.warn("LocalStorage store should not be used in production");
  }
  internalItems = /* @__PURE__ */ new Set();
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    this.internalItems.forEach((t) => {
      this.removeSessionItem(t);
    });
  }
  /**
   * Sets the provided key-value store to the localStorage cache.
   * @param {V} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(t, r) {
    if (await this.removeSessionItem(t), this.internalItems.add(t), typeof r == "string") {
      A(r, a.maxLength).forEach(
        (n, s) => {
          localStorage.setItem(
            `${a.keyPrefix}${t}${s}`,
            n
          );
        }
      );
      return;
    }
    localStorage.setItem(
      `${a.keyPrefix}${t}0`,
      r
    );
  }
  /**
   * Gets the item for the provided key from the localStorage cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(t) {
    if (localStorage.getItem(`${a.keyPrefix}${t}0`) === null)
      return null;
    let r = "", n = 0, s = `${a.keyPrefix}${String(t)}${n}`;
    for (; localStorage.getItem(s) !== null; )
      r += localStorage.getItem(s), n++, s = `${a.keyPrefix}${String(t)}${n}`;
    return r;
  }
  /**
   * Removes the item for the provided key from the localStorage cache.
   * @param {V} itemKey
   * @returns {void}
   */
  async removeSessionItem(t) {
    let r = 0;
    for (; localStorage.getItem(
      `${a.keyPrefix}${String(t)}${r}`
    ) !== null; )
      localStorage.removeItem(
        `${a.keyPrefix}${String(t)}${r}`
      ), r++;
    this.internalItems.delete(t);
  }
}
const a = {
  /**
   * The prefix to use for the storage keys.
   */
  keyPrefix: "kinde-",
  /**
   * The maximum length of the storage.
   *
   * If the length is exceeded the items will be split into multiple storage items.
   */
  maxLength: 2e3,
  /**
   * Use insecure storage for refresh token.
   *
   * Warning: This should only be used when you're not using a custom domain and no backend app to authenticate on.
   */
  useInsecureForRefreshToken: !1
}, m = async (e = o.accessToken) => {
  const t = y();
  if (!t)
    return null;
  const r = await t.getSessionItem(
    e === "accessToken" ? o.accessToken : o.idToken
  );
  if (!r)
    return null;
  const n = X(r);
  return n || console.warn("No decoded token found"), n;
}, M = async (e = "accessToken") => m(e), ae = async (e, t = "accessToken") => {
  const r = await M(t);
  return r ? {
    name: e,
    value: r[e]
  } : null;
}, ce = async () => {
  const e = await m();
  return e ? e.org_code || e["x-hasura-org-code"] : null;
}, ie = async (e = o.accessToken) => {
  const t = y();
  if (!t)
    return null;
  const r = await t.getSessionItem(
    e === "accessToken" ? o.accessToken : o.idToken
  );
  return r || null;
}, le = async (e) => {
  const t = await m();
  if (!t)
    return null;
  const r = t.feature_flags || t["x-hasura-feature-flags"];
  return r ? r[e]?.v ?? null : null;
}, ue = async () => {
  const e = await M("idToken");
  if (!e)
    return null;
  const { sub: t } = e;
  return t ? {
    id: e.sub,
    givenName: e.given_name,
    familyName: e.family_name,
    email: e.email,
    picture: e.picture
  } : (console.error("No sub in idToken"), null);
}, fe = async (e) => {
  const t = await m();
  if (!t)
    return {
      permissionKey: e,
      orgCode: null,
      isGranted: !1
    };
  const r = t.permissions || [];
  return {
    permissionKey: e,
    orgCode: t.org_code,
    isGranted: !!r.includes(e)
  };
}, de = async () => {
  const e = await m();
  if (!e)
    return {
      orgCode: null,
      permissions: []
    };
  const t = e.permissions || e["x-hasura-permissions"] || [];
  return {
    orgCode: e.org_code || e["x-hasura-org-code"],
    permissions: t
  };
}, he = async () => {
  const e = await m("idToken");
  return e ? !e.org_codes && !e["x-hasura-org-codes"] ? (console.warn(
    "Org codes not found in token, ensure org codes have been included in the token customisation within the application settings"
  ), null) : e.org_codes || e["x-hasura-org-codes"] : null;
}, ge = async () => {
  const e = await m();
  return e ? !e.roles && !e["x-hasura-roles"] ? (console.warn(
    "No roles found in token, ensure roles have been included in the token customisation within the application settings"
  ), []) : e.roles || e["x-hasura-roles"] : [];
}, ke = async (e) => {
  try {
    const t = await m("accessToken");
    if (!t) return !1;
    if (!t.exp)
      return console.error("Token does not have an expiry"), !1;
    const r = t.exp < Math.floor(Date.now() / 1e3);
    return r && e?.useRefreshToken ? (await x({
      domain: e.domain,
      clientId: e.clientId
    })).success : !r;
  } catch (t) {
    return console.error("Error checking authentication:", t), !1;
  }
}, x = async ({
  domain: e,
  clientId: t,
  refreshType: r = w.refreshToken,
  onRefresh: n
}) => {
  const s = (f) => (n && n(f), f);
  if (!e)
    return s({
      success: !1,
      error: "Domain is required for token refresh"
    });
  if (!t)
    return s({
      success: !1,
      error: "Client ID is required for token refresh"
    });
  let l = "", c;
  if (a.useInsecureForRefreshToken || !v(e) ? c = p() : c = y(), r === w.refreshToken) {
    if (!c)
      return s({
        success: !1,
        error: "No active storage found"
      });
    if (l = await c.getSessionItem(
      o.refreshToken
    ), !l)
      return s({
        success: !1,
        error: "No refresh token found"
      });
  }
  U();
  try {
    const f = await fetch(`${D(e)}/oauth2/token`, {
      method: "POST",
      ...r === w.cookie && { credentials: "include" },
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: new URLSearchParams({
        ...r === w.refreshToken && {
          refresh_token: l
        },
        grant_type: "refresh_token",
        client_id: t
      }).toString()
    });
    if (!f.ok)
      return s({
        success: !1,
        error: "Failed to refresh token"
      });
    const u = await f.json();
    if (u.access_token) {
      const i = y();
      return i ? (F(u.expires_in, async () => {
        x({ domain: e, clientId: t, refreshType: r, onRefresh: n });
      }), c && (await i.setSessionItem(
        o.accessToken,
        u.access_token
      ), u.id_token && await i.setSessionItem(o.idToken, u.id_token), u.refresh_token && await c.setSessionItem(
        o.refreshToken,
        u.refresh_token
      )), s({
        success: !0,
        [o.accessToken]: u.access_token,
        [o.idToken]: u.id_token,
        [o.refreshToken]: u.refresh_token
      })) : s({
        success: !1,
        error: "No active storage found"
      });
    }
  } catch (f) {
    return s({
      success: !1,
      error: `No access token received: ${f}`
    });
  }
  return s({
    success: !1,
    error: "No access token received"
  });
}, g = {
  secure: null,
  insecure: null
}, me = (e) => {
  g.secure = e;
}, y = () => g.secure || null, we = () => g.secure !== null, Se = () => {
  g.secure = null;
}, _e = (e) => {
  g.insecure = e;
}, p = () => g.insecure || g.secure || null, ye = () => g.insecure !== null, $e = () => {
  g.insecure = null;
}, ve = {
  __esModule: !0,
  default: async () => (await import("./expoSecureStore-vWl6fU1O.js")).ExpoSecureStore
};
export {
  ke as A,
  x as B,
  me as C,
  y as D,
  ve as E,
  we as F,
  Se as G,
  _e as H,
  p as I,
  ye as J,
  $e as K,
  se as L,
  ne as M,
  oe as N,
  q as O,
  V as P,
  I as Q,
  w as R,
  E as S,
  o as a,
  a as b,
  L as c,
  D as d,
  K as e,
  ee as f,
  C as g,
  re as h,
  te as i,
  v as j,
  F as k,
  U as l,
  J as m,
  _ as n,
  ae as o,
  M as p,
  ce as q,
  ie as r,
  A as s,
  m as t,
  le as u,
  ue as v,
  fe as w,
  de as x,
  he as y,
  ge as z
};
